var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-detail" },
    [
      _vm.code
        ? _c("OverlayProduct", {
            attrs: { code: _vm.code },
            on: { shop: _vm.goToShop }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-detail__share" },
        [
          _c("h3", {
            staticClass: "product-detail__share-title",
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.share.title"))
            }
          }),
          _vm._v(" "),
          _c("ShareButtons", {
            staticClass: "product-detail__share-buttons",
            attrs: {
              url: _vm.url,
              "email-subject": _vm.emailSubject,
              "email-text": _vm.emailText,
              "whatsapp-text": _vm.whatsappText,
              "facebook-text": _vm.facebookText,
              "twitter-text": _vm.twitterText
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }